<template>
  <div>
    <b-modal
      footer="{null}"
      centered
      id="my_numbers_details"
      title="Tous mes numéros"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="sidebar-card px-0 py-0 mb-0" id="other_sim_widget">
        <div>
          <div v-if="$store.state.core.subscriber == null">
            <b-skeleton width="100%"></b-skeleton>
            <b-skeleton animation="wave" width="100%"></b-skeleton>
            <b-skeleton animation="wave" width="100%"></b-skeleton>
          </div>
          <div v-if="$store.state.core.subscriber != null">
            <div
              class="other-sim-line"
              v-for="(phone_number, index) in $store.state.core.subscriber
                .numbers.others"
              :key="index"
              @click="doSomething(phone_number)"
            >
              <div
                v-if="
                  phone_number.msisdn !=
                  $store.state.core.subscriber.infos.msisdn
                "
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  w-100
                  flex-wrap
                "
              >
                <div class="d-flex align-items-top">
                  <i class="kgk-mtn-sim-card mr-2"></i>
                  <div>
                    <div>{{ phone_number.msisdn }}</div>
                    <div class="text-muted">
                      Enregistré le {{ phone_number.creation_date }}
                    </div>
                  </div>
                </div>
                <div>
                  <i class="mdi mdi-arrow-right momo-color"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import VFieldErrors from "@/components/utils/VFieldsErrors";
import { subscriber } from "@/services/";
import { required, length } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
extend("required", {
  ...required,
  message: "Champ obligatoire",
});
extend("length", {
  ...length,
  message: "Le numéro doit contenir 11 chiffres",
});
export default {
  name: "SimCodeMe2U",
  components: {
    VFieldErrors,
  },
  data: () => {
    return {
      is_ok: false,
      is_loading: false,
      current_step: 1,
      form: {
        code: "",
        confirm_code: "",
      },
    };
  },
  mounted() {},
  methods: {
    doSomething(element) {
      this.toggle_sim_details_sidebar(element);
      this.$bvModal.hide("my_numbers_details");
    },
  },
};
</script>
<style scoped lang="css">
#puk_details {
  font-weight: bold;
  font-size: 22px;
  letter-spacing: 2px;
}
::v-deep .modal-body {
  overflow-y: auto !important;
  max-height: 450px !important;
}
::v-deep label {
  font-size: 12px !important;
  margin-bottom: 3px !important;
  font-weight: 400 !important;
  font-weight: 700 !important;
}
::v-deep .form-text {
  font-size: 10px !important;
  color: #6c757d !important;
  font-weight: 400 !important;
}
::v-deep ::placeholder {
  color: #6c757d !important;
}
::v-deep .alert-warning {
  font-size: 12px !important;
  font-weight: 400 !important;
}
::v-deep select:focus,
input:focus {
  border: 1px solid #ced4da !important;
}
/* Chrome, Safari, Edge, Opera */
::v-deep input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0 !important;
}

/* Firefox */
::v-deep input[type="number"] {
  -moz-appearance: textfield !important;
}
.text-muted {
  font-size: 14px !important;
}
.other-sim-line:first-child {
  padding: 0 !important;
}
</style>